import React from 'react'
import classNames from 'classnames'

type Props = {
  icon?: React.ReactNode
  title: string
  description?: React.ReactNode
  action?: React.ReactNode
  tone?: 'neutral' | 'danger'
  compact?: boolean
}

const EmptyState: React.FC<Props> = ({
  icon,
  title,
  description,
  action,
  tone = 'neutral',
  compact
}) => (
  <div
    className={classNames('dx-empty', `dx-empty--${tone}`, {
      'dx-empty--compact': compact
    })}
    role={tone === 'danger' ? 'alert' : undefined}
  >
    {icon && <span className="dx-empty__icon">{icon}</span>}
    <p className="dx-empty__title">{title}</p>
    {description && <p className="dx-empty__body">{description}</p>}
    {action && <div className="dx-empty__action">{action}</div>}
  </div>
)

export default EmptyState
